module.exports = new __parcel__URL__("Charlie_Display-Semibold_Italic.1ac27bc5.woff2").toString();